// Function to validate the file type and size
export const validateImageFile = (file, maxSizeMB = 5) => {
    // Check if the file is not null or undefined
    if (!file) {
        return { valid: false, msg: "No file selected for upload" };
    }

    // Valid image types (jpeg, png, jpg)
    const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];

    // Check if the file type is valid
    if (!validImageTypes.includes(file.type)) {
        return { valid: false, msg: "Invalid image type. Please upload a JPEG or PNG image." };
    }

    // Check if the file size exceeds the max size
    const maxSize = maxSizeMB * 1024 * 1024; // Convert MB to bytes
    if (file.size > maxSize) {
        return { valid: false, msg: `File size exceeds the maximum limit of ${maxSizeMB}MB.` };
    }

    // If all checks pass, return valid
    return { valid: true };
};
